import ContactUsSubtitle from "../ContactUsSubtitle";
import SvgContactEmail from "./SvgContactEmail";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  email: string;
}

const ContactUsEmail: React.FC<Props> = ({ email }) => {
  const t = useTranslation();
  return (
    <div>
      <ContactUsSubtitle text={t.e_mail} />
      <div className="contact-us-email">
        <SvgContactEmail className="fill-primary" />
        {email}
      </div>
    </div>
  );
};
export default ContactUsEmail;
